import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Divider } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { helpStyles } from '../Help';
import srcSelectMenu from '../../../img/help/help_select_menu.jpg';
import srcBusinessProfileMenu from '../../../img/help/help_business_profile_menu.jpg';
import srcBusinessProfileSave from '../../../img/help/help_business_profile_save.jpg';
import srcBusinessProfileOnJobDetail from '../../../img/help/help_business_profile_on_jobdetail.jpg';
import { InfoBox } from '../../common/InfoBox';

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
    },
    ...helpStyles,
}));

const HelpBusinessProfile = () => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <InfoBox>
                <p>
                    企業紹介は設定しなくても求人投稿は可能ですが、設定していないと『企業紹介』ページにプロフィールが表示されなくなります。
                </p>
                <p>
                    ここで設定された項目は求人広告にも自動的に表示されます。内容の重複を避ける為、ここではあくまで企業・雇用主の紹介文やウェブサイトのリンクのみを記載し、求人内容は記述しない事をお勧めします。
                </p>
            </InfoBox>
            <Typography variant="body1" className={classes.helpLine}>
                ・画面右上、メニューをクリックまたはタップします
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcSelectMenu} alt="Select menu" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpLine}>
                ・メニューから『企業紹介編集』を選択し、編集ページへ移動します。
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcBusinessProfileMenu} alt="Business profile menu" className={classes.helpImageStyle} />
            </Box>

            <Divider className={classes.helpDivider} />

            <Typography variant="body1" className={classes.helpLine}>
                ・『企業紹介』ページで表示する為の画像、紹介文、ウェブサイトアドレス等を設定した後、画面下にある『変更を保存』ボタンを押して変更内容を保存してください。
            </Typography>
            <Box className={classes.helpImage}>
                <img src={srcBusinessProfileSave} alt="Business profile save" className={classes.helpImageStyle} />
            </Box>

            <Typography variant="body1" className={classes.helpInfoText}>
                ※ここで設定された画像と紹介文は、求人広告の方にも自動的に表示されます。
            </Typography>

            <Box className={classes.helpImage}>
                <img src={srcBusinessProfileOnJobDetail} alt="Business profile on job detail" className={classes.helpImageStyle} />
            </Box>

            <Typography variant="body1" className={classes.helpInfoText}>
                <strong>
                    ※このページで画像を最低一つアップロードし、且つ企業・雇用主紹介文を記入する事によって『
                    <Link to="/profiles" className={classes.helpLink}>
                        企業紹介
                    </Link>
                    』ページに企業情報が表示されるようになります。
                </strong>
            </Typography>
        </Box>
    )
}

export default HelpBusinessProfile
